<template>
    <v-list-item :key="call.id">
        <v-list-item-avatar v-if="call.from && call.from.user_id === currentUser.id">
            <v-icon color="primary">
                mdi-phone-outgoing
            </v-icon>
        </v-list-item-avatar>

        <v-list-item-avatar v-if="call.to && call.to.user_id ===
                                    currentUser.id">
            <v-icon color="accent">
                mdi-phone-incoming
            </v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
            <v-list-item-title v-if="call.from && call.from.user_id === currentUser.id">
                <DisplayParty v-if="call.to" :party="call.to"/>
            </v-list-item-title>
            <v-list-item-title v-else-if="call.to && call.to.user_id === currentUser.id">
                <DisplayParty v-if="call.from" :party="call.from"/>
            </v-list-item-title>
            <v-list-item-title v-else>
                Onbekend
            </v-list-item-title>
            <v-list-item-subtitle>
                {{ call.start_time | formattedDateTimeSec }} - {{ call.call_duration }} sec.
            </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
            <v-btn fab color="success" depressed small @click="emitPhonenumber">
                <v-icon color="white">
                    mdi-phone
                </v-icon>
            </v-btn>
        </v-list-item-action>
    </v-list-item>
</template>

<script>
import User from "@/models/User/User";
import DisplayParty from "@/components/PhoneCall/Party/DisplayParty";

export default {
    components: {DisplayParty},
    props: {
        call: {
            type: Object,
            required: true,
        },
    },
    computed: {
        currentUser() {
            return User.loggedInUser();
        },
    },
    methods: {
        emitPhonenumber() {
            if (this.call.from && this.call.from.user_id === this.currentUser.id && this.call.to) {
                this.$emit('selectedPhonenumber', this.call.to.phone_number);
            }
            else if (this.call.to && this.call.to.user_id === this.currentUser.id && this.call.from) {
                this.$emit('selectedPhonenumber', this.call.from.phone_number);
            }
            else {
                this.$emit('selectedPhonenumber', '');
            }
        }
    }
}
</script>
